import React from "react";

export const SocialLinks = () => {
  return (
    <div className="hidden lg:absolute right-[40px] bottom-[40px] lg:flex  items-start justify-start gap-[10px] w-fit">
      <img className="w-16" src="/images/linkedin.svg"></img>
      <img className="w-16" src="/images/instagram.svg"></img>
      <img className="w-16" src="/images/github.svg"></img>
    </div>
  );
};
